import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type * as fhirTypes from "fhir/r4";

interface EncounterParams {
  encounterId?: string;
  motherEncounterId?: string;
  patientId?: string;
}

export interface EncounterResponse {
  encounterId: string;
  adminNotes: fhirTypes.Communication[];
  assessment: fhirTypes.DocumentReference | null;
  careplan: fhirTypes.CarePlan | null;
  subjective: fhirTypes.DocumentReference | null;
  encounter: fhirTypes.Encounter;
  media: fhirTypes.DocumentReference[];
  medicalRequests: fhirTypes.MedicationRequest[];
  objectives: fhirTypes.Observation[];
  serviceRequests: fhirTypes.ServiceRequest[];
  billingCodes?: { code: string; display: string }[];
}

export const useTimelineEncounter = ({
  encounterId,
  motherEncounterId,
  patientId,
}: EncounterParams) => {
  return useApi<EncounterResponse>({
    queryOptions: {
      queryFn: async () => {
        const response = await axiosInstance.get<EncounterResponse>(
          `/charting/timeline/encounter/${encounterId}`,
        );

        return response.data;
      },
      enabled: !!encounterId,
      queryKey: QueryKeys.Patient.MedicalRecords.Timeline.ENCOUNTER({
        patientId,
        motherEncounterId,
        encounterId,
      }),
    },
  });
};
